import { Fragment,useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const Status = ({title, submitter }) =>{
      console.log("Found URL: "+ENDPOINT);
      const [primarytransactions, setPrimarytransactions] = useState([]);
      const [selected, setSelected] = useState(null);
      const [lstOpen, setOpen] = useState([]);
      const getList = async function(){
      		console.log("Effect");
		try {
		    const response = await fetch(ENDPOINT+"/transactions",
		    {
		    method: 'GET',
		    headers:{'Content-Type':'application/json'},
    		    });

		    console.log(response);
        if (response.ok){
		const data = await response.json();
		console.log("Data",data)
		setPrimarytransactions(data);
        }
      } catch (err) {
            console.log('error'+err);
      }

      }

      


      


   return (<><h2>System Status</h2>
   <p>
    Here, we show the system status
</p>
<h2>Primary Transactions in Backend</h2>
GUID: {selected}

<hr/>
<button onClick={()=>{getList();}} >Load...</button>
<DataTable value={primarytransactions} paginator
 selectionMode="single" selection={selected}
        onSelectionChange={(e) => {setSelected(e["value"]["guid"]);}}
rows={12} tableStyle={{ minWidth: '50rem' }}>
    <Column field="last_touched" header="Active" ></Column>
    <Column field="guid" header="GUID"></Column>
    <Column field="ttype" header="Type" ></Column>
    <Column field="state" header="State"></Column>
    
</DataTable>

<h2>Last Worker Visits</h2>
<ul>
<li> 22.1.2025 - Title of whatever</li>
<li> 22.1.2025 - Title of whatever</li>
<li> 22.1.2025 - Title of whatever</li>
<li> 22.1.2025 - Title of whatever</li>
<li> 22.1.2025 - Title of whatever</li>
</ul>
</>);
};
export default Status;